import { readCookie } from "@/mixins/helpers";
import { uuid } from "vue-uuid";

export default {
  computed: {
    albumNameKey() {
      const album =
        {
          production: "",
          local: "university-logo",
        }[import.meta.env.VITE_APP_ENV] ?? import.meta.env.VITE_APP_ENV;
      return album === "" ? "" : encodeURIComponent(album) + "/";
    },
  },
  methods: {
    async s3Upload(file, newName) {
      const fileKey = this.albumNameKey + newName;

      const formData = new FormData();
      formData.append("file", file);
      formData.append("fileKey", fileKey);

      return fetch("/api/s3-univ-upload", {
        method: "POST",
        headers: {
          "X-XSRF-Token": readCookie("XSRF-TOKEN"),
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((s3) => {
          if (s3?.result?.Location) {
            return {
              Location: s3.result.Location,
              Bucket: s3.result.Bucket,
              key: fileKey,
            };
          } else {
            const error = new Error(s3.message || "Upload connection failed");
            error.code = s3.code || 500;
            throw error;
          }
        });
    },
    createUUIDName(name) {
      const lastIndex = name.lastIndexOf(".");
      const fileExtension = name.substring(lastIndex);

      return uuid.v4() + fileExtension;
    },
    fileName(name) {
      const nameParts = name.split(".");
      const extension = nameParts.pop();

      const maxFileNameLength = 79 - extension.length;
      const fileName = nameParts.join(".").substring(0, maxFileNameLength);

      return [fileName, extension].join(".");
    },
  },
};
